<template>
    <div class="two_table">
        <div class="inputCont">
            <el-form
                style="width: 100%"
                class="leader-style-form leader-form-inner-tab-inline"
                :inline="screen"
            >
                <el-row :gutter="20">
                    <el-col :span="24" style="text-align: right">
                        <!-- <el-button
                            @click="getDeviceLedgerList"
                            size="small"
                            class="leader-common-button"
                            >查询222</el-button
                        > -->
                        <el-button
                            class="leader-common-button"
                            @click="addItem"
                            size="small"
                            >新增</el-button
                        ></el-col>
                </el-row>
            </el-form>
        </div>

        <!-- -------------------------- -->
        <!-- table布局 -->
        <div
            class="table-wrap"
            style="height: 100%; width: 100%"
            v-loading="loading"
        >
            <el-table
                class="leader-style-table"
                :data="tableList"
                ref="multipleTable"
                height="100%;"
            >
                <el-table-column
                    label="站房名称"
                    property="device_ledger_name"
                ></el-table-column>
                <el-table-column
                    label="站房类型"
                    property="device_ledger_type_name"
                ></el-table-column>
                <el-table-column
                    label="站房电压等级"
                    property="grade"
                ></el-table-column>
                <el-table-column
                    label="配变总容量(kVA)"
                    property="total_capacity"
                ></el-table-column>
                <el-table-column
                    label="资产编号"
                    property="assets_number"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="资产性质"
                    property="assets_nature"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="资产单位"
                    property="assets_unit"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="投运日期"
                    property="up_time"
                    align="center"
                ></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="viewItem(scope.row)"
                            type="text"
                            class="leader-button start-button"
                        >
                            <i class="iconfont iconchakan"></i>
                            <span class="inner-text">查看</span>
                        </el-button>
                        <el-button
                            @click="changeItem(scope.row)"
                            type="text"
                            class="leader-button edit-button"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="deleteItemShow(scope.row)"
                            type="text"
                            class="leader-button del-button"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
                v-if="this.paginationData.totalNum"
            ></pagination>
        </div>
        <!-- -------------------------------- -->
        <!-- 新增dialog -->
        <el-dialog
            title="变电所台账管理"
            class="leader-dialog"
            :visible.sync="addshow"
            :close-on-click-modal="false"
            @close="dialogClose('addForm')"
        >
            <div class="substation_outer_wrapper">
                <div class="table-container" style="width: 100%;">
                    <el-form
                        label-width="150px"
                        :model="addForm"
                        :rules="addRules"
                        ref="addForm"
                        class="leader-style-form"
                        :show-message="false"
                    >
                        <el-scrollbar style="height: 22rem;margin-right: -1px">
                            <el-row :gutter="20">
                                <div class="circle_wrapper">
                                    <div class="circle_title">运行参数</div>
                                    <el-col :span="12">
                                        <el-form-item label="站房名称" prop="device_ledger_name" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.device_ledger_name"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="站房类型" prop="device_ledger_type" label-width="120px">
                                            <el-select
                                                v-model="addForm.device_ledger_type"
                                                placeholder="请选择站房类型"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in deviceLedgerList"
                                                    :key="item.code_value"
                                                    :label="item.code_name"
                                                    :value="item.code_value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="站房电压等级" prop="grade" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.grade"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="配变总容量(kVA)" prop="total_capacity" label-width="150px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.total_capacity"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="投运日期" prop="up_time" label-width="120px">
                                            <el-date-picker
                                                v-model="addForm.up_time"
                                                align="right"
                                                type="date"
                                                :clearable="false"
                                                placeholder="选择日期"
                                                value-format="yyyy-MM-dd"
                                                :picker-options="pickerOptions"
                                            ></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <div style="clear: both"></div>
                                </div>
                                <div class="circle_wrapper">
                                    <div class="circle_title">资产参数</div>
                                    <el-col :span="12">
                                        <el-form-item label="资产编号" prop="assets_number" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.assets_number"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="资产性质" prop="assets_nature" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.assets_nature"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="资产单位" prop="assets_unit" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.assets_unit"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <div style="clear: both"></div>
                                </div>
                                <div class="circle_wrapper">
                                    <div class="circle_title">物理参数</div>
                                    <el-col :span="12">
                                        <el-form-item label="所属区域" prop="area" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.area"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="站址" prop="site" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.site"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="纬度" prop="latitude" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.latitude"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="经度" prop="longitude" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.longitude"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="备注"
                                            label-width="120px"
                                            prop="remark"
                                        >
                                            <el-input
                                                type="textarea"
                                                :rows="6"
                                                maxlength="200"
                                                v-model="addForm.remark"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <div style="clear: both"></div>
                                </div>
                            </el-row> 
                        </el-scrollbar>
                    </el-form>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    @click="addshow = false"
                    class="leader-common-button"
                    size="small"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    @click="addcommit"
                    :disabled="this.$store.state.btnType"
                    size="small"
                    class="leader-common-button"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
        <!-- -------------------------------- -->
        <!-- 查看dialog -->
        <el-dialog
            class="leader-dialog equipment_dialog"
            title="查看"
            :visible.sync="detailsShow"
            :close-on-click-modal="false"
        >
        <!-- <div class="circle_wrapper">
                                    <div class="circle_title">其他参数</div> -->
            <el-scrollbar style="height: 22rem;margin-right: -1px">
                <div
                    v-for="(value, key) in detailTableData"
                    :key="key"
                    class="circle_wrapper"
                >
                    <div class="circle_title">{{ key }}</div>
                    <mailTable
                        :tableData="value"
                        :tableStyle="{ width: '100%' }"
                    ></mailTable>
                </div>
            </el-scrollbar>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "../api/substation_device_manage";
import pagination from "@/comon/components/pagination.vue";
import { getCodelistByKind, uploadAvatar } from "@/http/api.js";
import Tree from "@/comon/components/tree.vue";
import mailTable from "@/comon/components/TableComponent.vue";
export default {
    components: {
        pagination,
        //BtnDialog,
        "me-tree": Tree,
        mailTable: mailTable
    },
    props: ["treeId", "treeLevel", "treeData"],
    data() {
        return {
            types: [],
            tableList: [],
            width: "calc(100% - 250px)",
            paginationData: {
                pageNum: "",
                pageSize: "",
                totalNum: "",
            },
            searchForm: {
                company_name: '',
                equipment_name: '',
                equipment_num: '',
            },
            addshow: false,
            addForm: {
                device_ledger_name: "",
                device_ledger_type: "",
                grade: "",
                total_capacity: "",
                up_time: null,
                assets_number: '',
                assets_nature: '',
                assets_unit:'',
                area:'',
                site: '',
                latitude: '',
                longitude: '',
                remark: '',
            },
            addRules: {
                device_ledger_name: [
                    {
                        required: true,
                        message: "请填写站房名称",
                        trigger: "blur",
                    },
                ],
                device_ledger_type: [
                    {
                        required: true,
                        message: "请选择站房类型",
                        trigger: "change",
                    },
                ],
                // grade: [
                //     {
                //         required: true,
                //         message: "请输入站房电压等级",
                //         trigger: "blur",
                //     },
                // ],
                // up_time: [
                //     {
                //         required: true,
                //         message: "请选择投运日期",
                //         trigger: "change",
                //     },
                // ],
                // total_capacity: [
                //     {
                //         required: true,
                //         message: "请输入配变总容量(kVA)",
                //         trigger: "blur",
                //     },
                // ],
            },
            flag: true,
            btnVsb: false,
            title: "新增按钮",
            menuId: "",
            btnId: "",
            loading: false,
            equipmentStateList: [],
            detailsShow: false,
            detailTableData: {},
            isAdd: true,
            deviceLedgerList: [],
        };
    },
    created() {
        this.getCodelistByKind();
    },
    methods: {
        getCodelistByKind() {
            getCodelistByKind({
                code_kind: "device_ledger_type_30",
            }).then((res) => {
                if (res) {
                    this.deviceLedgerList = res.bus_json[0].codelists;
                }
            });
        },
        getDeviceLedgerList() {
            this.loading = true;
            api.getDeviceLedgerList({
                p_device_ledger_id: this.treeId,
                device_ledger_kind: this.treeData.device_ledger_kind,
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize,
            }).then((res) => {
                this.tableList = res.bus_json.items;
                this.paginationData.pageNum = res.bus_json.pageNum;
                this.paginationData.pageSize = res.bus_json.pageSize;
                this.paginationData.totalNum = res.bus_json.totalNum;
              //  this.$refs.multipleTable.doLayout();
            });
            this.loading = false;
        },
        //  table新增按钮点击
        addItem() {
            this.isAdd = true;
            this.width = "calc(100% - 250px)";
            this.addForm = {
                device_ledger_name: "",
                device_ledger_type: "",
                grade: "",
                total_capacity: "",
                up_time: null,
                assets_number: '',
                assets_nature: '',
                assets_unit:'',
                area:'',
                site: '',
                latitude: '',
                longitude: '',
                remark: '',
            }
            this.addshow = true;
        },
        deleteFile() {
            this.addForm.file_id = '';
            this.addForm.file_name = '';
            this.addForm.file_path = '';
            this.addForm.all_file_path = '';
        },
        // 分页器公共方法
        paginationDataNew(sth) {
            this.paginationData = sth;
            this.getDeviceLedgerList();
        },
        // 新增资源提交
        addcommit() {
            this.$refs["addForm"].validate((valid) => {
                if(!this.treeId) {
                    this.$message({
                        message: '请选择设备',
                        type: "warning",
                    });
                    return;
                }
                if (valid) {
                    const param = [{
                        ...this.addForm
                    }];
                    if(this.isAdd) {
                        param.map(item => {
                            item.p_device_ledger_id = this.treeId;
                            item.device_ledger_kind = this.treeData.device_ledger_kind;
                        })
                    }
                    api.saveDeviceLedger(param).then((res) => {
                        if (res) {
                            this.$message({
                                message: res.error_msg,
                                type: "success",
                            });
                            this.getDeviceLedgerList();
                            this.diaClose();
                        }
                    });
                }
            });
        },
        // 所有关闭dialog的清除验证的回调
        diaClose() {
            this.addshow = false;
            this.$emit('reloadTree');
        },
        // table内点击修改弹窗
        changeItem(sth) {
            this.isAdd = false;
            this.width = "100%";
            api.selectByDeviceLedgerId({
                device_ledger_id: sth.device_ledger_id,
            }).then((res) => {
                if (res) {
                    this.addForm = res.bus_json;
                    this.addshow = true;
                    this.treeId1 = this.addForm.power_supply_type_id;
                    // this.$nextTick(() => {
                    //     this.$refs.subtree1.$refs.tree.setCurrentKey(
                    //         this.addForm.power_supply_type_id
                    //     );
                    //     this.defaultExpandedKeys1 = [this.addForm.power_supply_type_id];
                    // });
                }
            });
        },
        viewItem(sth) {
            this.detailTableData = {};
            api.selectByDeviceLedgerId({
                device_ledger_id: sth.device_ledger_id,
            }).then((res) => {
                if (res) {
                    this.detailTableData['运行参数'] = [
                        {key: '站房名称', value: res.bus_json.device_ledger_name},
                        {key: '站房类型', value: res.bus_json.device_ledger_type_name},
                        {key: '站房电压等级', value: res.bus_json.grade},
                        {key: '配变总容量(kVA)', value: res.bus_json.total_capacity},
                        {key: '投运日期', value: res.bus_json.up_time},
                    ];
                     this.detailTableData['资产参数'] = [
                        {key: '资产编号', value: res.bus_json.assets_number},
                        {key: '资产性质', value: res.bus_json.assets_nature},
                        {key: '资产单位', value: res.bus_json.assets_unit},
                    ];
                    this.detailTableData['物理参数'] = [
                        {key: '所属区域', value: res.bus_json.area},
                        {key: '站址', value: res.bus_json.site},
                        {key: '纬度', value: res.bus_json.latitude},
                        {key: '经度', value: res.bus_json.longitude},
                        {key: '备注', value: res.bus_json.remark},
                    ];
                    this.detailsShow = true;
                }
            });
        },
        // 删除menuTable的一项
        deleteItemShow(sth) {
            this.$confirm("确认删除该数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deleteDeviceLedger({ device_ledger_id: sth.device_ledger_id }).then(res => {
                    if (res) {
                        // 最后一页，只有一条数据时，点击删除
                        if (
                            this.paginationData.totalNum -
                                (this.paginationData.pageNum - 1) *
                                    this.paginationData.pageSize ==
                            1
                        ) {
                            // 处理页码显示问题
                            this.paginationData.pageNum =
                                this.paginationData.pageNum == 1
                                    ? this.paginationData.pageNum
                                    : this.paginationData.pageNum - 1;
                        }
                        // 刷新列表
                        this.getDeviceLedgerList();
                        this.diaClose();
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
        // 附件上传
        doUploadFile(file) {
            const isLt2M = file.file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 10MB!,请重新上传！");
                return;
            }
            // const file_type_name = this.$refs.fjupload.$attrs.row
            //     .file_type_name;
            let formData = new FormData();
            formData.append("file", file.file);
            formData.append("file_type", "20");
            // formData.append("file_type_name", file_type_name);
            uploadAvatar(formData).then((res) => {
                if (res && res.error_code == "0") {
                    this.addForm.file_id = res.bus_json.file_id;
                    this.addForm.file_path = res.bus_json.file_path;
                    this.addForm.all_file_path = res.bus_json.all_file_path;
                    this.addForm.file_name = res.bus_json.file_name;
                    this.$message({
                        type: "success",
                        message: res.error_msg,
                    });
                }
            });
        },
    },
    watch: {
        treeId(newVal) {
            if(newVal) {
                this.paginationData = {
                    pageNum: "1",
                    pageSize: "10",
                    totalNum: "",
                };
                this.tableList = [];
                this.getDeviceLedgerList();
            }
        },
    },
};
</script>
<style lang='scss'>
.two_table {
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 90px);
    
    .inputCont {
        padding: 8px 0;
        margin: 0 !important;
    }
    .el-dialog {
        width: 1000px;
    }
    .leader-style-form {
        &::after {
            height: 0;
        }
    }
    .circle_wrapper {
        border: 3px solid #1a6292; 
        padding: 30px 20px 0 30px;
        margin: 8px 0 20px 0;
        position: relative;
        .circle_title {
            position: absolute; top:-0; left: 20px; transform: translate(0, -50%); color: #fff;background-color: #0b1929;font-size: 14px;
        }
    }
    .leader-style-table .el-table__body-wrapper {
        height: 90% !important;
    }
    .color_green {
        color: #009788;
    }
    .color_red {
        color: red;
    }
    .leader-tab {
        position: relative;
        .btnContainer {
            width: auto;
            position: absolute;
            right: 32px;
            top: -29px;
        }
    }
}

</style>


